import React from 'react';
import classNames from 'classnames';
import * as helper from '../../../helper/html-helper';
import AASLogo from '../../icons/aas_logo';
import styles from './headerTab.scss';
import TabNavigationHelper from '../../../helper/tabNavigationHelper';

export default class HeaderTab extends React.Component<{
    logoSrc?: string, title?: string,
    description?: string, tabKey: string,
    onTabChange, activeTab: string, cdnAssetsUrl?: string
    },
    { logoSrc?: string }> {

    private tabNavigation: TabNavigationHelper;
    constructor(props) {
        super(props);
        this.state = { logoSrc: undefined };
        this.tabNavigation = TabNavigationHelper.instance;
    }

    componentDidMount() {
        if (this.props.logoSrc && this.props.cdnAssetsUrl)
            this.setState(
                { logoSrc: helper.formCdnUrl(this.props.logoSrc, this.props.cdnAssetsUrl) }
            );
    }

    public render() {
        return (
            <div className={classNames(styles.tab_container,
                { [styles.isActive]: this.props.tabKey === this.props.activeTab})}
                onClick={this.props.onTabChange}
                data-tabkey={this.props.tabKey}
                data-testid='pa_header_tab' data-semantic-id='pa_header_tab' 
                ref={(el)=>this.tabNavigation.setFocusAtt(el)}
                onKeyDown={this.tabNavigation.handleKeyDown}
                >
                <div className={styles.t_logo}>
                {
                        this.state.logoSrc ?
                            <img className={classNames(styles.logo_img, styles.tf_logo)} src={this.state.logoSrc}
                                alt={helper.decodeHTML(this.props.title + '-' + this.props.description)} />
                            :
                            <div className={classNames(styles.logo_img, styles.aas_logo)}
                                title={helper.decodeHTML(this.props.title)}>
                                <AASLogo />
                            </div>
                    }
                </div>
                <div className={styles.t_text_area}>
                    <div className={styles.t_title}>{
                        helper.decodeHTML(this.props.title)
                    }</div>
                    <div className={styles.t_description}>{
                        helper.decodeHTML(this.props.description)
                    }</div>
                </div>
            </div>
        );
    }
}

